import { JSX } from 'react';
import { Configurator, InfoContainer, TabDrawer, Unauthenticated } from '.';
import { useAuth } from 'oidc-react';
import { authSettings } from '../api/OidcSettings';
import { ConfigurationValidationDialog } from './ConfigurationValidationDialog';
import { UrlHelper, IsAppOpenedInIframe, IsAppOpenedByExtApp } from '../services';
import { AppAuthContext } from '../services/Contexts';
import { DefaultFlow, EPageNames, ESessionStore, EUrlParams } from '../data/Constants';
import { SessionStore } from '../services/SessionStore';
import { useLocation, useNavigate } from 'react-router';
/**
 * Container to render the home screen
 * @returns {JSX.Element} the home screen which includes the TabDrawer, Configurator and Infocontainer
 */
export const Home = (): JSX.Element | null => {
  const location = useLocation();
  const navigate = useNavigate();

  let token = '';

  if (!authSettings.Developer_Mode && !IsAppOpenedInIframe() && !IsAppOpenedByExtApp()) {
    const auth = useAuth(); //Do not move this line outside of this function, as it will cause an error for Hybris scenario
    if (!auth?.userData) {
      return <Unauthenticated />;
    }
    token = auth.userData.access_token;
  } else {
    token = UrlHelper.getSearchParameter(EUrlParams.Token) ?? SessionStore.get(ESessionStore.Token);
  }

  //After SSO Login return landing page if flow is 'complete' else navigate to Home page
  //Return null if authentication search params are not removed yet
  if (location.search.includes('session_state')) {
    if (SessionStore.get(ESessionStore.Flow) === DefaultFlow) {
      navigate(EPageNames.LandingPage, { replace: true });
    }
    return null;
  }

  return (
    <AppAuthContext.Provider value={token}>
      <TabDrawer />
      <Configurator />
      <InfoContainer />
      <ConfigurationValidationDialog />
    </AppAuthContext.Provider>
  );
};
